module.exports = __webpack_public_path__ + "img/lk-mode-circle.41d049ec.svg";